
export const name = "video-player-ui";
export const version = "1.33580";
